import { Component, OnInit } from '@angular/core';
import { SalesService, Users, UserRole, UserPermissions } from 'src/app/shared/services/sales.service';
import { SectorsService, sectorslist } from 'src/app/shared/services/sectors.service';
import { StatusService, statuslist } from 'src/app/shared/services/status.service';
import { RegionsService, Region } from 'src/app/shared/services/regions.service';
import {SelectButtonModule} from 'primeng/selectbutton';
import { UserConfig, UserConfigService } from 'src/app/shared/services/user-config.service';
import * as $ from 'jquery';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {


  constructor(private salesService: SalesService, private  sectorsService: SectorsService, private  statusService: StatusService,
              private  regionService: RegionsService , private userConfigservice :UserConfigService) { }

  useremail = sessionStorage.getItem('loginUserName');
  public currentLoggedUserList : Users[];
  public role: UserRole = new UserRole();
  /*role.roleId=-1;
    role.userRole="";
    role.userManagement = false;
    role.customerManagement = false;
    role.lookupManagement = false;*/

      isVisible = false;
  
      toggleVisibility() {
          this.isVisible = !this.isVisible;
      }
  
  

    //button
    selectedType: boolean;
    buttontypes: any[] = [
      { label: 'ON', value: true },
      { label: 'OFF', value: false }
    ];


    onEmailActionChange(isSend: boolean) {

      const config: UserConfig = {
        email: this.useremail,
        isActive: isSend,
      };

      // console.log("send "+ this.useremail + " " + isSend);

      this.userConfigservice.updateIsAction(config).subscribe(response => {
        // console.log("Response from backend:", response);
      });

    }


  public currentLoggedUser : Users = new Users();
   //-1,-1,-1,-1,-1,"","","","","","", this.role);
  public sectorList: sectorslist[];
  public statusList: statuslist[];
  public regionsList: Region[];
  public managersList : Users[];
  public userPermissionList : UserPermissions[];
  public errorMsg;
  manager: string;
  public salesUsers: Users[] = new Array();//new Users(-1,-1,-1,-1,-1,"","","","","","", this.role)};


  async ngOnInit(): Promise<void> {
    $("body").css("overflow-y", "hidden");

    await this.loadLists();
    await this.populateManager();

    // Spinner
    $(".spinner-container").fadeOut();
    $("body").css("overflow-y", "auto");

    this.userConfigservice.checkUserIsActive(this.useremail).subscribe(
      (isActive: boolean) => {
        this.selectedType = isActive ;
      },
      (error) => {
        console.error("Error checking if user is active: ", error);
      }
    );

  }

  async loadLists(){

    await this.salesService.findUserByEmail(this.useremail).toPromise().then(response =>{ this.currentLoggedUserList = response; this.currentLoggedUser = this.currentLoggedUserList[0];});
    await this.salesService.retrieveManagers().toPromise().then(response =>{ this.managersList = response;});
    await this.salesService.retrievePermissions(this.currentLoggedUser.userId).toPromise().then(response =>{ this.userPermissionList = response;});
    await this.sectorsService.getsectorsList().toPromise().then(response =>{this.sectorList = response;});
    await this.regionService.getRegions().toPromise().then(response =>{this.regionsList = response;},error => this.errorMsg = error);
    await this.salesService.findSalesUsersByManager("All", "All").toPromise().then(
      response =>{

        // console.log("findSalesUsersByManager : "+ response);
        // console.log(response);

        response.forEach(userData =>
        {
          if (userData.email !== sessionStorage.getItem('loginUserName')){
            populateManagerName(userData.managerId, this.managersList, userData);
            this.salesUsers.push(userData);
          }
       });
      },
      error => this.errorMsg = error
     );
  }

  async populateManager(){

    for (let index = 0; index < this.managersList.length; index++) {
      const element = this.managersList[index];
      let managerUser = <Users>element;
      //console.log(managerUser.userId);
      //console.log(this.currentLoggedUser.managerId);
      if (managerUser.userId==this.currentLoggedUser.managerId){
        this.manager = managerUser.firstName +" " + managerUser.lastName;
        break;
      }
    }

        //console.log(this.manager);
  }



}

function populateManagerName(managerId: number, usersList: Users[], userData: Users) {
  //console.log("received manager Id: "+managerId);
  for (var j = 0; j < usersList.length; j++) {
    var option = usersList[j];
    //console.log("userid from list : "+option.userId);
    //console.log(option)
    if (option.userId === managerId) {
      userData.manager = option.firstName + " " + option.lastName;
      break;
    }
  }
}
